import React, { useMemo } from "react";
import PropTypes from "prop-types";
import DrugInteractionFilter from "../Filter";
import {
  Divider,
  Flex,
  Icon,
  Type,
} from "discover.medical.react-component-library";

import { DrugInteractionsSeverityIndexButton } from "../styled";

const DrugInteractionResultsHeader = ({
  filterLabel,
  filterOptions,
  interactionsCount,
  severityIndex,
  selectedInteractionType,
  setSelectedInteractionType,
  handleInfoIconClick,
}) => {
  const selectedInteractionLabel = useMemo(() => {
    const option = filterOptions.find(
      (opt) => opt.type === selectedInteractionType
    );
    return option ? `${option.label} (${interactionsCount}):` : "";
  }, [selectedInteractionType, filterOptions, interactionsCount]);

  return (
    <>
      <Flex container justify={{ content: "space-between" }} marginBottom="lg">
        <Flex
          cell
          align={{ self: "stretch" }}
          span={8}
          children={
            <DrugInteractionFilter
              label={filterLabel}
              options={filterOptions}
              value={selectedInteractionType}
              onChange={setSelectedInteractionType}
            />
          }
        />
        <Flex cell>
          <DrugInteractionsSeverityIndexButton
            kind="anchor"
            onClick={handleInfoIconClick}
          >
            {severityIndex.title}
            <Icon icon={severityIndex.icon} />
          </DrugInteractionsSeverityIndexButton>
        </Flex>
      </Flex>

      <Type
        element="h3"
        styledAs="h5"
        fontWeight="bold"
        textTransform="uppercase"
        marginBottom="sm"
      >
        {selectedInteractionLabel}
      </Type>

      <Divider />
    </>
  );
};

DrugInteractionResultsHeader.propTypes = {
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  interactionsCount: PropTypes.number.isRequired,
  severityIndex: PropTypes.shape({
    title: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      size: PropTypes.string.isRequired,
      glyph: PropTypes.string.isRequired,
    }),
  }),
  filterLabel: PropTypes.string.isRequired,
  selectedInteractionType: PropTypes.string.isRequired,
  setSelectedInteractionType: PropTypes.func.isRequired,
  handleInfoIconClick: PropTypes.func.isRequired,
};

DrugInteractionResultsHeader.displayName = "DrugInteractionResultsHeader";

export default DrugInteractionResultsHeader;
